import { render, staticRenderFns } from "./LpFooter.vue?vue&type=template&id=cac1edc2&scoped=true"
import script from "./LpFooter.vue?vue&type=script&lang=js"
export * from "./LpFooter.vue?vue&type=script&lang=js"
import style0 from "./LpFooter.vue?vue&type=style&index=0&id=cac1edc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cac1edc2",
  null
  
)

export default component.exports